exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nohover[data-v-627aa1f4]:hover{opacity:.3!important;color:#000!important}.hate.on.nohover[data-v-627aa1f4]:hover{opacity:1!important;color:#4590ec!important}.like.on.nohover[data-v-627aa1f4]:hover{opacity:1!important;color:#f46969!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-627aa1f4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChatArea.vue
// module id = 307
// module chunks = 0